import React from 'react';
import styled from 'styled-components';

function MultipleTicketTypesInformation() {
    return (
        <Wrapper className="multiple-ticket-types-information">
            <p className="title">
                <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 -0.000976562C15.524 -0.000976562 20.002 4.47702 20.002 10.001C20.002 15.524 15.524 20.002 10 20.002C4.476 20.002 1.6749e-07 15.524 1.6749e-07 10.001C-0.000999833 4.47702 4.476 -0.000976562 10 -0.000976562ZM9.996 8.24902C9.75093 8.24936 9.51452 8.33967 9.33165 8.50282C9.14878 8.66596 9.03218 8.89058 9.004 9.13402L8.997 9.25002L9.001 14.752L9.007 14.869C9.03519 15.1129 9.15211 15.3379 9.33549 15.5011C9.51887 15.6644 9.75589 15.7544 10.0014 15.7542C10.2469 15.7539 10.4837 15.6634 10.6668 15.4998C10.8498 15.3362 10.9663 15.111 10.994 14.867L11 14.75L10.996 9.24902L10.989 9.13202C10.9601 8.88878 10.8429 8.66461 10.6597 8.50203C10.4765 8.33945 10.24 8.24978 9.995 8.25002L9.996 8.24902ZM10.001 4.50002C9.66908 4.50002 9.35076 4.63188 9.11606 4.86658C8.88135 5.10128 8.7495 5.4196 8.7495 5.75152C8.7495 6.08344 8.88135 6.40176 9.11606 6.63647C9.35076 6.87117 9.66908 7.00302 10.001 7.00302C10.3329 7.00289 10.6512 6.87091 10.8858 6.63611C11.1204 6.40132 11.2521 6.08294 11.252 5.75102C11.2519 5.4191 11.1199 5.10083 10.8851 4.86623C10.6503 4.63162 10.3319 4.49989 10 4.50002H10.001Z"
                        fill="#4AA3C8"
                    />
                </svg>
                Detta evenemang innehåller olika biljettyper
            </p>
            <p className="description">
                Barnbiljetter kan läggas till efter att ni valt antal vuxenbiljetter.
            </p>
        </Wrapper>
    );
}

export { MultipleTicketTypesInformation };

const Wrapper = styled.div`
    padding: 12px 18px;

    background: #E8F6FA;

    border: 1px dashed #0a0a0a;
    border-radius: 4px;

    position: relative;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    
    p {
        margin-bottom: 0;
        width: 100%;
    }

    .title {
        font-size: 16px;
        line-height: 21px;
        font-weight: 700;
        font-family: Adelle, serif;
        
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }

    .description {
        font-size: 14px !important;
        line-height: 18px !important;
        max-width: none;
        margin-top: 4px;
        margin-bottom: 0 !important;
    }
`;
